module.exports = __webpack_public_path__ + "static/media/allie04.d54033c3.jpg";